import { Component, OnInit } from '@angular/core';
import { LoginService } from '../login.service';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.css']
})
export class LogoutComponent implements OnInit {

  constructor(private loginService: LoginService) { }

  ngOnInit() {
    this.doLogout();
  }


  doLogout() {
    this.loginService.doLogout().subscribe(() => {
      window.top.location.href = window.location.origin;
    }, error => {
      window.top.location.href = window.location.origin;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/logout/logout.component.ts